var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#007ACC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6083 33.9324C34.6083 34.2155 34.4958 34.4871 34.2956 34.6873C34.0954 34.8875 33.8239 35 33.5407 35H16.4592C16.1761 35 15.9045 34.8875 15.7043 34.6873C15.5041 34.4871 15.3916 34.2155 15.3916 33.9324V20.712C15.3915 20.5493 15.4286 20.3887 15.5 20.2426C15.5714 20.0964 15.6753 19.9685 15.8037 19.8686L24.3445 13.2249C24.5319 13.0792 24.7625 13 25 13C25.2374 13 25.4681 13.0792 25.6555 13.2249L34.1962 19.8686C34.3246 19.9685 34.4285 20.0964 34.4999 20.2426C34.5714 20.3887 34.6084 20.5493 34.6083 20.712V33.9324ZM32.4731 32.8648V21.233L25 15.421L17.5268 21.233V32.8648H32.4731Z",
    fill: "#007ACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonHome);
export default __webpack_public_path__ + "static/media/buttonHome.3ec03440421bebdc343def89bf13cf10.svg";
export { ForwardRef as ReactComponent };